var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconLeafMulticolor = function IconLeafMulticolor(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "iconLeafMulticolor_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 33,
    width: 22,
    height: 29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.917 60.939a2.943 2.943 0 01-.84-4.076l14.77-22.442a2.943 2.943 0 114.916 3.236L6.993 60.099a2.943 2.943 0 01-4.076.84z",
    fill: "#49B975"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#iconLeafMulticolor_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.544 60.225l17.98-27.371.762-.1 1.46 3.294-3.222 5.967-6.61 16.601-12.469 4.627 2.099-3.018z",
    fill: "#005D37"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.71 48.144c-4.374.095-7.184-1.343-8.802-2.208l5.005-11.102 12.39-9.871c7.059-4.575 18.162-14.684 20.312-16.41 2.686-2.155 8.06-7.459 9.675-6.936C61.327 1.95 61.5 3 61.334 3.674c-.725 2.03-2.776 6.426-3.752 8.834-.977 2.408-4.134 8.878-5.728 11.496-1.595 2.617-5.021 8.008-6.919 10.278-1.897 2.27-5.76 6.298-5.76 6.298-1.494 1.399-4.494 4.316-7.535 5.538-3.8 1.527-5.961 1.94-9.928 2.026z",
    fill: "#005D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.267 6.673c3.313-.948 6.259-2.264 7.8-3.3 1.543-1.037 2.478-1.785 4.508-2.05 2.03-.263 2.575.956 2.575.956S36.532 21.076 28.305 27.458c-8.226 6.38-15.094 17.835-15.392 18.519 0 0-2.62-2.085-3.668-3.393-1.047-1.309-1.873-3.24-2.326-4.987-.454-1.747-.606-4.85-.07-8.66.647-4.6 3.402-8.583 4.87-10.153 3.176-3.392 7.302-6.346 13.146-8.034 6.963-2.01 6.989-1.813 11.937-2.458 3.932-.512 4.312-.216 9.465-1.62z",
    fill: "#4EAE7D"
  }));
};

IconLeafMulticolor.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconLeafMulticolor;
//# sourceMappingURL=IconLeafMulticolor.js.map